import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

// https://observablehq.com/@d3/contours@262
import define1 from "./a33468b95d0b15b0@704.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject || (_templateObject = _taggedTemplateLiteral(["# Contours\n\nShowing the [Goldstein\u2013Price test function](https://en.wikipedia.org/wiki/Test_functions_for_optimization)."])));
  });
  main.variable(observer("value")).define("value", function () {
    return function (x, y) {
      return (1 + Math.pow(x + y + 1, 2) * (19 - 14 * x + 3 * Math.pow(x, 2) - 14 * y + 6 * x * y + 3 * Math.pow(y, 2))) * (30 + Math.pow(2 * x - 3 * y, 2) * (18 - 32 * x + 12 * x * x + 48 * y - 36 * x * y + 27 * Math.pow(y, 2)));
    };
  });
  main.variable(observer()).define(["legend", "color"], function (legend, color) {
    return legend({
      color: color,
      title: "Value",
      tickFormat: ","
    });
  });
  main.variable(observer("chart")).define("chart", ["d3", "width", "height", "contours", "color", "xAxis", "yAxis"], function (d3, width, height, contours, color, xAxis, yAxis) {
    var svg = d3.create("svg").attr("viewBox", [0, 0, width + 28, height]).style("display", "block").style("margin", "0 -14px").style("width", "calc(100% + 28px)");
    svg.append("g").attr("fill", "none").attr("stroke", "#fff").attr("stroke-opacity", 0.5).selectAll("path").data(contours).join("path").attr("fill", function (d) {
      return color(d.value);
    }).attr("d", d3.geoPath());
    svg.append("g").call(xAxis);
    svg.append("g").call(yAxis);
    return svg.node();
  });
  main.variable(observer("color")).define("color", ["d3", "thresholds"], function (d3, thresholds) {
    return d3.scaleSequentialLog(d3.extent(thresholds), d3.interpolateMagma);
  });
  main.variable(observer("thresholds")).define("thresholds", ["d3"], function (d3) {
    return d3.range(1, 20).map(function (i) {
      return Math.pow(2, i);
    });
  });
  main.variable(observer("grid")).define("grid", ["width", "height", "value", "x", "y"], function (width, height, value, x, y) {
    var q = 4; // The level of detail, e.g., sample every 4 pixels in x and y.

    var x0 = -q / 2,
        x1 = width + 28 + q;
    var y0 = -q / 2,
        y1 = height + q;
    var n = Math.ceil((x1 - x0) / q);
    var m = Math.ceil((y1 - y0) / q);
    var grid = new Array(n * m);

    for (var j = 0; j < m; ++j) {
      for (var i = 0; i < n; ++i) {
        grid[j * n + i] = value(x.invert(i * q + x0), y.invert(j * q + y0));
      }
    }

    grid.x = -q;
    grid.y = -q;
    grid.k = q;
    grid.n = n;
    grid.m = m;
    return grid;
  });
  main.variable(observer("transform")).define("transform", ["grid"], function (grid) {
    return function (_ref) {
      var type = _ref.type,
          value = _ref.value,
          coordinates = _ref.coordinates;
      return {
        type: type,
        value: value,
        coordinates: coordinates.map(function (rings) {
          return rings.map(function (points) {
            return points.map(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  x = _ref3[0],
                  y = _ref3[1];

              return [grid.x + grid.k * x, grid.y + grid.k * y];
            });
          });
        })
      };
    };
  });
  main.variable(observer("contours")).define("contours", ["d3", "grid", "thresholds", "transform"], function (d3, grid, thresholds, transform) {
    return d3.contours().size([grid.n, grid.m]).thresholds(thresholds)(grid).map(transform);
  });
  main.variable(observer("x")).define("x", ["d3", "width"], function (d3, width) {
    return d3.scaleLinear([-2, 2], [0, width + 28]);
  });
  main.variable(observer("y")).define("y", ["d3", "height"], function (d3, height) {
    return d3.scaleLinear([-2, 1], [height, 0]);
  });
  main.variable(observer("xAxis")).define("xAxis", ["height", "d3", "x", "width"], function (height, d3, x, width) {
    return function (g) {
      return g.attr("transform", "translate(0,".concat(height, ")")).call(d3.axisTop(x).ticks(width / height * 10)).call(function (g) {
        return g.select(".domain").remove();
      }).call(function (g) {
        return g.selectAll(".tick").filter(function (d) {
          return x.domain().includes(d);
        }).remove();
      });
    };
  });
  main.variable(observer("yAxis")).define("yAxis", ["d3", "y"], function (d3, y) {
    return function (g) {
      return g.attr("transform", "translate(-1,0)").call(d3.axisRight(y)).call(function (g) {
        return g.select(".domain").remove();
      }).call(function (g) {
        return g.selectAll(".tick").filter(function (d) {
          return y.domain().includes(d);
        }).remove();
      });
    };
  });
  main.variable(observer("height")).define("height", function () {
    return 600;
  });
  main.variable(observer("d3")).define("d3", ["require"], function (require) {
    return require("d3@6");
  });
  var child1 = runtime.module(define1);
  main.import("legend", child1);
  return main;
}